import { UserProvider } from './../user/user';
import { Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { FirebaseProvider } from '../firebase/firebase';
import { GlobalVars } from '../../app/app.environment';
import { File } from '@ionic-native/file';
import { FileOpener} from '@ionic-native/file-opener'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CheckProvider } from '../check/check';
import { User } from '../../models/user';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable()
export class ReportProvider {

  public monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  
  public colorCodesCheckType = { Entrada: '#33ff33', Pausa: '#aaaaaa', Reanudar: '#5555ff', Salida: '#ff3333' }
  public colorCodesRelative = { 
    'Entrada antes de tiempo / Salida con retraso': '#33ff33',
    'Entrada con retraso / Salida antes de tiempo': '#ff3333',
    'Otros': '#aaaaaa' 
  }

  public monthTable = [];
  public documentPDF;
  
  constructor(
    public platform: Platform,
    public file: File,
    public fileOpener: FileOpener,
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
    public checkProvider: CheckProvider,
    public userProvider: UserProvider,
  ) {}

  userReport(beginMonth: Date, endMonth: Date, selectedUser: User, relativeTime: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      var curMonth = new Date(beginMonth);
      var finalMonth = new Date(endMonth);
  
      var minDate = new Date(curMonth);
      minDate.setHours(0);
  
      var maxDate = new Date(finalMonth);
      maxDate.setHours(0);
      maxDate.setMonth(maxDate.getMonth() + 1);
  
      this.checkProvider.getUserChecksBetweenDatesOnce(minDate, maxDate, selectedUser.key).subscribe(checks => {
  
        checks.map(timestampToDate);
  
        function timestampToDate(check) {
          check['data'] = new Date(check.timestamp);
          return check;
        }  
  
        // Inicialització del document
        this.documentPDF = {
          header: { text: `Resumen ${selectedUser.name}`, style: 'header' },
          
          content: [],
  
          styles: {
            header: {
              fontSize: 22,
              bold: true,
              alignment: 'center',
              margin: [0, 10],
            },
            table: {
              margin: [0, 2, 0, 20],
              fontSize: 9,
            },
            tableHeader: {
              bold: true,
              fontSize: 20,
            },
            tableSubHeader: {
              bold: true,
              fontSize: 12,
            },
            captionHeader: {
              bold: true,
              fontSize: 16
            }
          },
  
          pageMargins: [ 20, 50, 0, 20 ],
        };
  
        var num = 0;
  
        while(curMonth <= finalMonth) {
          // Calcular mínim i màxim timestamp per filtrar els fitxatges per mesos
          var minDateMonth = new Date(curMonth);
          minDateMonth.setHours(0);
      
          var maxDateMonth = new Date(curMonth);
          maxDateMonth.setHours(0);
          maxDateMonth.setMonth(maxDateMonth.getMonth() + 1);
          
          var minTimestampMonth = minDateMonth.getTime();
          var maxTimestampMonth = maxDateMonth.getTime();
          var checksMonth = checks.filter(check => check.timestamp >= minTimestampMonth && check.timestamp < maxTimestampMonth);
  
          this.createMonthUserReport(curMonth, minDateMonth, maxDateMonth, checksMonth, num, relativeTime);
          curMonth.setMonth(curMonth.getMonth() + 1);
          num++;   
        }
  
        // Ajuntar totes les parts i generar pdf
        for (let i = 0; i < this.monthTable.length; i++) {
          this.documentPDF.content.push(this.monthTable[i]);
        }
  
        // Eliminar últim salt de pàgina
        this.documentPDF.content[this.documentPDF.content.length-1][3]['pageBreak'] = null;

        this.makePdf(this.documentPDF, 'Resumen_mensual.pdf')
          .then(() => resolve(true))
          .catch(error => reject(error))
      });
    })
  }

  private createMonthUserReport(selectedMonth, minDateMonth, maxDateMonth, checks, num, relativeTime: boolean) {

    // Comprovar dies que té aquell mes
    var date = new Date(selectedMonth);  
    
    var captionCode = relativeTime ? this.colorCodesRelative : this.colorCodesCheckType;
    var caption = this.generateCaptionCheckType(captionCode);
    
    this.monthTable[num] = 
    [ { text: this.monthNames[date.getMonth()], style: 'tableHeader', alignment: 'left' },
          
      {
        table: {
          headerRows: 1,
          widths: [ 100 ],

          body: [
            [ { text: 'Fecha', style: 'tableSubHeader', alignment: 'left' } ],
          ],
        },
        style: 'table',
      },

      { text: 'Leyenda', style: 'captionHeader' },

      caption
    ]

    // Generar tantes files com dies tingui aquell mes
    while(minDateMonth < maxDateMonth) {
      this.monthTable[num][1].table.body.push([{ text: minDateMonth.toLocaleDateString(), alignment: 'left' }]);
      minDateMonth.setDate(minDateMonth.getDate() + 1);
    }

    // Afegir una fila més per al total
    this.monthTable[num][1].table.body.push([{ text: 'Total', alignment: 'left', bold: true }]);
  

    // Omplir les files amb els fitxatges
    for(let i = 0; i < checks.length; i++) {
      let dateString = checks[i].data.toLocaleDateString();
      let type = checks[i].type;

      checks[i].dateString = dateString;

      // Mode temps absolut
      if(!relativeTime) {
        let hour = checks[i].data.toLocaleTimeString();
        this.monthTable[num][1].table.body.filter(check => check[0].text == dateString)[0].push({ text: hour, alignment: 'center', fillColor: captionCode[type] });
      }

      // Mode tems relatiu
      else {
        let delay = checks[i].delayString ? delayFormat(checks[i].delayString) : ' - - - - ';
        let color;

        if(type == 'Entrada' && checks[i].delay < 0) color = captionCode['Entrada antes de tiempo / Salida con retraso'];
        else if(type == 'Salida' && checks[i].delay > 0) color = captionCode['Entrada antes de tiempo / Salida con retraso'];
        else if(type == 'Entrada' && checks[i].delay > 0) color = captionCode['Entrada con retraso / Salida antes de tiempo'];
        else if(type == 'Salida' && checks[i].delay < 0) color = captionCode['Entrada con retraso / Salida antes de tiempo'];
        else color = captionCode['Otros'];

        this.monthTable[num][1].table.body.filter(check => check[0].text == dateString)[0].push({ text: delay, alignment: 'center', fillColor: color });
      }

    }

    // Buscar número màxim de fitxatges en un dia
    var maxChecks = 0;

    for(let i = 0; i < this.monthTable[num][1].table.body.length; i++) {
      if(maxChecks < this.monthTable[num][1].table.body[i].length) {
        maxChecks = this.monthTable[num][1].table.body[i].length
      }
    }

    // Omplir els forats buits per guardar correctament l'estructura del JSON
    for(let i = 0; i < this.monthTable[num][1].table.body.length; i++) {
      while(this.monthTable[num][1].table.body[i].length < maxChecks) {
        this.monthTable[num][1].table.body[i].push({ text: '', alignment: 'left' });
      }
    }

    var monthTotal = 0;

    // Omplir files amb les hores totals
    for(let i = 0; i < this.monthTable[num][1].table.body.length; i++) {
      
      // 1a fila
      if(i == 0) {
        this.monthTable[num][1].table.body[i].push({ text: 'Total', style: 'tableSubHeader', alignment: 'center' });
      }

      // Última fila
      else if(i == this.monthTable[num][1].table.body.length - 1) {
        this.monthTable[num][1].table.body[i].push({ text: msToTime(monthTotal, 'total', 0), alignment: 'center', bold: true });
      }
      
      // Files del mig
      else {
        let dateString = this.monthTable[num][1].table.body[i][0].text;
  
        let time = this.calculateTime(checks.filter(check => check.dateString == dateString))
        this.monthTable[num][1].table.body[i].push({ text: msToTime(time.total, 'total', time.error), alignment: 'center', bold: true });
      
        // Acumular total del mes
        if(time.error == 0) monthTotal += time.total;
      }
    }
    
    // Configurar columnes
    while(this.monthTable[num][1].table.widths.length < maxChecks + 1) {
      this.monthTable[num][1].table.widths.push('auto');
    }
  }
  
  globalReport(beginMonth: Date, endMonth: Date) {
    
    return new Promise((resolve, reject) => {
      var selectedChecks = [];

      this.userProvider.getUsersPublicDataOnce().subscribe(users => {
        
        console.log(users)
  
        users.forEach(user => {
          selectedChecks.push({ key: user.key, name: user.name, checks: []});
          return false;
        })
  
        console.log(selectedChecks);
  
        var curMonth = new Date(beginMonth);
        var finalMonth = new Date(endMonth);
    
        var minDate = new Date(curMonth);
        minDate.setHours(0);
    
        var maxDate = new Date(finalMonth);
        maxDate.setHours(0);
        maxDate.setMonth(maxDate.getMonth() + 1);
  
        this.checkProvider.getChecksBetweenDatesOnce(minDate, maxDate).subscribe(checks => {
          
          checks.forEach(check => {
            var key = check.userKey;

            let user = selectedChecks.find(user => user.key == key)
            if (user) user['checks'].push(check)
          })
    
          console.log(selectedChecks);
    
          // Inicialització del document
          this.documentPDF = {
            header: { text: `Resumen global`, style: 'header' },
            
            content: [],
    
            styles: {
              header: {
                fontSize: 22,
                bold: true,
                alignment: 'center',
                margin: [0, 10],
              },
              table: {
                margin: [0, 2, 0, 20],
                fontSize: 9,
              },
              tableHeader: {
                bold: true,
                fontSize: 20,
              },
              tableSubHeader: {
                bold: true,
                fontSize: 12,
              },
              llegendaHeader: {
                bold: true,
                fontSize: 16
              }
            },
    
            pageOrientation: 'landscape',
            pageMargins: [ 20, 50, 0, 20 ],
          };
          
  
          // Iterar per mesos
          while(minDate < maxDate) {
  
            console.log('MES')
  
            var taulaPart1 = [[]];
            var taulaPart2 = [[]];
  
            // Omplir primera columna, que conté els noms dels usuaris
            for (let i = 0; i < selectedChecks.length; i++) {
              taulaPart1[0].push({ text: selectedChecks[i].name });
              taulaPart2[0].push({ text: selectedChecks[i].name });
            }
  
            console.log(taulaPart1)
            console.log(taulaPart2)
  
            
            var minDateMonth = new Date(minDate);
            minDateMonth.setHours(0);
        
            var maxDateMonth = new Date(minDate);
            maxDateMonth.setHours(0);
            maxDateMonth.setMonth(maxDateMonth.getMonth() + 1);
                 
            var capPart1: Array<any> = [{ text: 'Nombre' }];
            var capPart2: Array<any> = [{ text: 'Nombre' }];
            var dia = 1;
            var tempsTotal = (new Array(selectedChecks.length)).fill(0)// = 0;
            var totalPauses = (new Array(selectedChecks.length)).fill(0)// = 0;
  
            // Iterar per dies
            while(minDateMonth < maxDateMonth) {
  
              if(minDateMonth.getDate() <= 16) capPart1.push({ text: dia });
              else capPart2.push({ text: dia });
              
              var minTimestamp = minDateMonth.getTime();
  
              var nextDay = new Date(minDateMonth);
              nextDay.setDate(nextDay.getDate() + 1);
              var maxTimestamp = nextDay.getTime();
      
              // Iterar per cada usuari
              for (let i = 0; i < selectedChecks.length; i++) {
                var checksDia = selectedChecks[i].checks.filter(check => check.timestamp >= minTimestamp && check.timestamp < maxTimestamp);
                var temps = this.calculateTime(checksDia);
  
                if(temps.error == 0) {
                  tempsTotal[i] += temps.total;
                  totalPauses[i] += temps.pauses;
                }
  
                /*
                console.log(temps.total, temps.pauses);
                console.log(taulaPart1)
                console.log(taulaPart2)
                console.log(minDateMonth.getDate(), i)
                */
  
                if(minDateMonth.getDate() <= 16) {
                  if(taulaPart1[minDateMonth.getDate()] == null) taulaPart1[minDateMonth.getDate()] = [];
                  taulaPart1[minDateMonth.getDate()][i] = ({ text: msToTime(temps.total, 'total', temps.error) });
                }
                
                else {
                  if(taulaPart2[minDateMonth.getDate()-16] == null) taulaPart2[minDateMonth.getDate()-16] = [];
                  taulaPart2[minDateMonth.getDate()-16][i] = ({ text: msToTime(temps.total, 'total', temps.error) });
                }
              }
  
              dia++;
              minDateMonth.setDate(minDateMonth.getDate() + 1);
            }
  
  
            capPart2.push({ text: 'Total' });
            capPart2.push({ text: 'Pauses' });
  
            // Iterar per cada usuari
            var length = taulaPart2.length;
  
            for (let i = 0; i < selectedChecks.length; i++) {
              console.log(tempsTotal[0], totalPauses[0])
              if(taulaPart2[length] == null) taulaPart2[length] = [];
              taulaPart2[length][i] = ({ text: msToTime(tempsTotal[i], 'total', 0) });
              
              if(taulaPart2[length+1] == null) taulaPart2[length+1] = [];
              taulaPart2[length+1][i] = ({ text: msToTime(totalPauses[i], 'pauses', 0) });
            }
  
            for (let i = 0; i < taulaPart1.length; i++) {
              taulaPart1[i].unshift(capPart1[i]);
            }
  
            for (let i = 0; i < taulaPart2.length; i++) {
              taulaPart2[i].unshift(capPart2[i]);
            }
  
            //taulaPart1.unshift(capPart1);
            //taulaPart2.unshift(capPart2);
  
            // Generar taules PDF (2 cada mes) *******************************************
  
            taulaPart1 = taulaPart1[0].map((col, i) => taulaPart1.map(row => row[i]));
            taulaPart2 = taulaPart2[0].map((col, i) => taulaPart2.map(row => row[i]));
            
  
            var mesPart1 = 
              [ { table: null, text: this.monthNames[minDate.getMonth()] + ' - 1a parte', style: 'tableHeader', alignment: 'left' },
                    
                {
                  table: {
                    headerRows: 1,
                    widths: [ 'auto' ],
          
                    body: [],
                  },
                  style: 'table',
                  pageBreak: 'after',
                },
              ]
  
            var mesPart2 = 
              [ { table: null, text: this.monthNames[minDate.getMonth()] + ' - 2a parte', style: 'tableHeader', alignment: 'left' },
                    
                {
                  table: {
                    headerRows: 1,
                    widths: [ 'auto' ],
          
                    body: [],
                  },
                  style: 'table',
                  pageBreak: 'after',
                },
              ];
  
            // Omplir amplades restants
            for (let i=1; i < taulaPart1[0].length; i++) {
              mesPart1[1].table.widths.push('auto');
            }
  
            // Omplir el contingut de la taula
            for (let i=0; i < taulaPart1.length; i++) {
              mesPart1[1].table.body.push(taulaPart1[i]);
            }
            
            // Omplir amplades restants
            for (let i=1; i < taulaPart2[0].length; i++) {
              mesPart2[1].table.widths.push('auto');
            }
  
            // Omplir el contingut de la taula
            for (let i=0; i < taulaPart2.length; i++) {
              mesPart2[1].table.body.push(taulaPart2[i]);
            }
  
            this.documentPDF.content.push(mesPart1);
            this.documentPDF.content.push(mesPart2);
            
  
            minDate.setMonth(minDate.getMonth() + 1);
          }
  
          console.log(this.documentPDF);
  
          // Eliminar últim salt de pàgina
          this.documentPDF.content[this.documentPDF.content.length-1][1]['pageBreak'] = null;
          
          this.makePdf(this.documentPDF, 'Resumen_mensual.pdf')
            .then(() => resolve(true))
            .catch(error => reject(error))
        });
      });  
    })
  }
  

  private generateCaptionCheckType(codiColors) {
    var colorNames = Object.keys(codiColors);

    var caption = { 
      table: {
        headerRows: 0,
        widths: [ 'auto', 100 ],

        body: [],
      },
      style: 'table',
      pageBreak: 'after'
    }
    
    for (let i = 0; i < colorNames.length; i++) {
      caption.table.body.push([{ text: colorNames[i] }, { text: '', fillColor: codiColors[colorNames[i]] }]);
    }
    
    return caption;
  }


  private calculateTime(dayChecks: any) {
    if(dayChecks.length == 0) 
      return { error: -1, total: 0, pauses: 0 };

    else {
      var date = new Date(dayChecks[0].timestamp).toDateString();
      var dateToday = new Date().toDateString();

      if(date == dateToday)
        return { error: -2, total: 0, pauses: 0 };

      else {
        let date, newTimestamp;

        // Afegir una entrada simbòlica en primera posició si no existeix
        if(dayChecks[0].type != 'Entrada') {
          date = new Date(dayChecks[0].timestamp);
          newTimestamp = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();
    
          dayChecks.unshift({ type: 'Entrada', timestamp: newTimestamp, delay: 0 });
        }
    
        // Afegir una sortida simbòlica en primera posició si no existeix
        if(dayChecks[dayChecks.length-1].type != 'Salida') {
          date = new Date(dayChecks[0].timestamp);
          newTimestamp = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 0, 0, 0, 0).getTime();
    
          dayChecks.push({ type: 'Salida', timestamp: newTimestamp, delay: 0 });
        }
    
        // Càlcul de temps treballat
        let total = 0;
        let pauses = 0;
        let begin, end, range;
        let pauseBegin, pauseEnd, pauseRange;
        let state;
  
        while(dayChecks.length > 0) {

          if(dayChecks[0].type == 'Entrada') {
            begin = dayChecks[0].timestamp;
            state = 'treballant';
          }

          else if(dayChecks[0].type == 'Reanudar') {
            begin = dayChecks[0].timestamp;
            state = 'treballant';

            pauseEnd = dayChecks[0].timestamp
            pauseRange = pauseEnd - pauseBegin;
            pauses += pauseRange;
          }

          else if(dayChecks[0].type == 'Pausa') {
            end = dayChecks[0].timestamp;
            range = end - begin;
            
            if(state == 'treballant') {
              total += range;
            }
            
            state = 'descansant';
            pauseBegin = dayChecks[0].timestamp;
            console.log('Pausa', pauseBegin);
          }
          
          else {
            end = dayChecks[0].timestamp;
            range = end - begin;
            
            if(state == 'treballant') {
              total += range;
            }
            state = 'descansant';
          }
  
          dayChecks.shift();
        }
  
        return { error: 0, total: total, pauses: pauses };
      }
    }
  }


  private makePdf(docDefinition, name): Promise<any> {
    var name = name.replace(' ', '_');
    var directori;
    
    if(this.platform.is('android')) directori = this.file.externalRootDirectory;
    else if(this.platform.is('ios')) directori = this.file.documentsDirectory;

    if(this.platform.is('cordova')) {
      console.log('Mòbil')

      return new Promise((resolve, reject) => {
        pdfMake.createPdf(docDefinition).getBlob(buffer => {
        this.file.resolveDirectoryUrl(directori)
          .then(dirEntry => {
            this.file.getFile(dirEntry, name, { create: true })
              .then(fileEntry => {
                fileEntry.createWriter(writer => {
                  writer.onwrite = () => {
                    this.fileOpener.open(fileEntry.toURL(), 'application/pdf')
                      .then(res => resolve(true))
                      .catch(err => reject(err));
                  }
                  writer.write(buffer);
                })
              }).catch(err => reject(err));
          }).catch(err => reject(err));
        })
      })
    }

    else {
      console.log('Navegador')

      return new Promise(resolve => {
        pdfMake.createPdf(docDefinition).download(name);
        resolve(true);
      })
    }
  }
}

function delayFormat(string) {
  return string.split(':')[1];
}


function msToTime(ms, mode, error) {
  
  if(mode == 'total' && error == -1) return ' ';
  if(mode == 'total' && error == -2) return 'En curso';

  var h, m, s;
  s = Math.floor(ms / 1000);
  m = Math.floor(s / 60);
  s = s % 60;
  h = Math.floor(m / 60);
  m = m % 60;

  m = Math.abs(m);
  s = Math.abs(s);

  s = s.toString();  if(s.length == 1) s = '0' + s;
  m = m.toString();  if(m.length == 1) m = '0' + m;
  h = h.toString();  if(h.length == 1 || (h.length == 2 && h[1] == '-')) h = '0' + h;
  
  return h + ':' + m + ':' + s;
}



// WEBPACK FOOTER //
// ./src/providers/report/report.ts